import { Router } from 'lucide-react';

// Icône routeur : lucide, comme le reste des icônes de l'UI (RouterOS n'a pas de logo à dessiner).
export function RouterIcon({ size = 14, className = '' }) {
  return <Router size={size} strokeWidth={1.75} className={className} />;
}

// Logos plateforme (Windows / Linux) — lucide-react n'a pas de logos de marque,
// ces deux icônes sont dessinées à la main en monochrome (currentColor) pour
// rester cohérentes avec le reste des icônes de l'UI (Copy, Check, Terminal…).

export function WindowsIcon({ size = 14, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
      <path d="M0 3.449L9.75 2.1v9.451H0m10.949-9.602L24 0v11.4H10.949M0 12.6h9.75v9.451L0 20.699M10.949 12.6H24V24l-13.051-1.351" />
    </svg>
  );
}

export function TuxIcon({ size = 14, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className}>
      <ellipse cx="12" cy="14.5" rx="6.5" ry="8.5" />
      <circle cx="12" cy="6.5" r="4" />
      <ellipse cx="6.2" cy="13" rx="1.6" ry="3.6" transform="rotate(-18 6.2 13)" />
      <ellipse cx="17.8" cy="13" rx="1.6" ry="3.6" transform="rotate(18 17.8 13)" />
      <ellipse cx="9.3" cy="22.3" rx="1.9" ry="1.1" />
      <ellipse cx="14.7" cy="22.3" rx="1.9" ry="1.1" />
      <path d="M10.7 7.6h2.6L12 9.4z" />
    </svg>
  );
}
